<dw-router-parent>
  <ng-template>
    <div dwRow>
      <div dwCol="12">
        <div class="acs-trends-container">
          <!-- Page Header -->
          <header class="page-header">
            <div class="page-heading-icon"><i class="fas fa-chart-line"></i></div>
            <div>
              <h1>ACS Missed Code Trends</h1>
              <p class="page-description">
                Analyze missed ACS codes across checkrides and plans of action to identify training gaps and patterns
              </p>
            </div>
          </header>

          <!-- Generic Tag-Based Filters -->
          <div class="report-filter-bar">
            <app-generic-tag-filters [filterConfigs]="filterConfigs" [autoRefresh]="true"
              (filtersChanged)="onFiltersChanged($event)">
            </app-generic-tag-filters>

            <div class="chart-data-toggle" title="Choose whether report charts or their data tables display first">
              <dw-yesno
                [options]="chartDataToggleOptions"
                [ngModel]="!showChartGridFirstByDefault"
                (ngModelChange)="onShowChartGridFirstByDefaultChanged(!$event)">
              </dw-yesno>
            </div>
          </div>

          <!-- Tab Navigation -->
          <div class="report-navigation-row">
            <div class="report-navigation" *ngIf="acsTrendsConfig?.tabs?.length">
              <dw-pills [items]="acsTrendsConfig.tabs" [(ngModel)]="currentTabName" valueField="tabName"
                displayField="tabLabel" (ngModelChange)="setActiveTab($event)">
              </dw-pills>
            </div>
          </div>
          <!-- Current Tab Description -->
          <div class="tab-description" *ngIf="currentTab">
            <i [class]="currentTab.iconClass"></i>
            <span>{{ currentTab.description }}</span>
          </div>

          <!-- Main Content Area -->
          <div class="dashboard-content">
            <!-- Detail Grid (shown on drill-down) -->
            <ng-container *ngIf="showGrid">
              <dw-container
                [options]="{showTitle: true, useContainerStyling: true, containerHeaderBackgroundColor: 'blue'}">
                <div header>
                  {{ selectedDataInfo?.label }}
                </div>
                <div body class="inner-container">
                  <dw-meta-data-grid [item]="'roAssessmentAcsMissedCodeFact'" [configKeyPart]="currentTab.gridConfigKey"
                    [filters]="gridFilters">
                  </dw-meta-data-grid>
                </div>
              </dw-container>
            </ng-container>

            <!-- Charts and Visualizations (hidden when grid is shown) -->
            <div [hidden]="showGrid" class="visualizations-container">
              <!-- Loading Indicator -->
              <div *ngIf="isLoadingChart" class="loading-indicator">
                <i class="fas fa-spinner fa-spin fa-2x"></i>
                <p>Loading data...</p>
              </div>

              <!-- Pattern 1-4: Chart Visualizations -->
              <div *ngIf="!isLoadingChart && currentTabName !== 'pivot'" class="chart-container">
                <dw-chart-tile *ngIf="chartData?.length > 0" [chartPreferences]="chartPreferences" [data]="chartData"
                  [gridSourceData]="chartGridData"
                  (dataSelected)="onChartDataSelected($event)" [query]="query">
                  <div *ngIf="selectedDataInfo && currentTab.allowDataDrillDown">
                    <a (click)="toggleGrid()" class="dw-link">
                      View Details for {{ selectedDataInfo.label }}
                    </a>
                  </div>
                </dw-chart-tile>

                <div *ngIf="chartData?.length === 0" class="no-data-message">
                  <i class="fas fa-chart-bar fa-3x"></i>
                  <p>No data available for the selected filters</p>
                  <small>Try adjusting your filters or selecting a different date range</small>
                </div>
              </div>

              <!-- Pattern 5: Pivot Grid -->
              <div *ngIf="!isLoadingChart && currentTabName === 'pivot'" class="pivot-container">
                <div class="pivot-controls">
                  <div class="pivot-controls-title">Group By Fields</div>
                  <div class="pivot-field-options">
                    <label class="pivot-field-option" *ngFor="let dimension of visiblePivotDimensions">
                      <input
                        type="checkbox"
                        [ngModel]="selectedPivotDimensions.includes(dimension.key)"
                        (ngModelChange)="onPivotDimensionToggled(dimension.key, $event)" />
                      <span>{{ dimension.label }}</span>
                    </label>
                  </div>
                </div>

                <div *ngIf="chartData?.length > 0">
                  <div class="pivot-quick-grid-container dw-total-row-grid" *ngIf="query">
                    <dw-quick-grid
                      [item]="query.RootTable"
                      [useFlexColumns]="true"
                      [query]="query"
                      [columnPreferences]="pivotQuickGridColumnPreferences"
                      (gridEvent)="onPivotGridEvent($event)"
                      [ConfigKeyPart]="pivotGridConfigKey"
                      [allowConfiguration]="true">
                    </dw-quick-grid>
                  </div>
                </div>

                <div *ngIf="chartData?.length === 0" class="no-data-message">
                  <i class="fas fa-table fa-3x"></i>
                  <p>No data available for the selected filters</p>
                  <small>Try adjusting your filters or selecting a different date range</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</dw-router-parent>
